const axios = require('axios');
const { getHashKey } = require('./util/hash');
const { getScriptOrigin } = require('./util');
const { getMyBusinessUrl } = require('./constants/sites/mybusiness');
const { getMyPagesUrl } = require('./constants/sites/mypages');
const { getMobilityMyPagesUrl } = require('./constants/sites/mobility');
const { getMobilityOpenPagesUrl } = require('./constants/sites/mobility');
const { hideFromMobilityUrl } = require('./constants/sites/mobility-hide');

class IfHelp2015Api {
    #activeIdentityKey = undefined;
    #chatIdentity = undefined;
    #featureToggles = [];

    init() {
        return new Promise((resolve, reject) => {
            let i = 0;
            const timer = setInterval(() => {
                i++;
                if (typeof window.iimclient !== 'undefined') {
                    clearInterval(timer);
                    resolve();
                }
            }, 1000);

            if (i === 10) {
                clearInterval(timer);
                reject();
            }
        });
    }

    setFloaterIcons() {
        const iimclient = window.iimclient;

        if (this.hashCheckWCB()) {
            // This means user was linked #web-callback to show the callback tab in panel. Do not show chat
        } else if (
            !iimclient.segment ||
            (iimclient.segment &&
                iimclient.segment.chatqueue &&
                iimclient.segment.floater_chatisvisible) ||
            (iimclient.segment && iimclient.segment.chatqueue && iimclient.testURLMapping)
        ) {
            if (!iimclient.chatIsDisabled) {
                window.NordicTracking.panel().setFunction(
                    window.NordicTracking.PANELINFO_FUNCTION_NAME_CHAT,
                    window.NordicTracking.PANELINFO_FUNCTION_STATUS_AVAILABLE
                );
            } else if (iimclient.segment && iimclient.segment.chatlaunch == 'skip_form') {
                // do nothing
            } else if (!iimclient.hideChatBox) {
                window.NordicTracking.panel().setFunction(
                    window.NordicTracking.PANELINFO_FUNCTION_NAME_CHAT,
                    window.NordicTracking.PANELINFO_FUNCTION_STATUS_DIMMED
                );
            }
        } else {
            window.NordicTracking.panel().removeFunction(
                window.NordicTracking.PANELINFO_FUNCTION_NAME_CHAT
            );
        }

        if (
            !iimclient.segment ||
            (iimclient.segment.floater_phoneisvisible && !iimclient.segment.url_hide_phone_icon) ||
            iimclient.testURLMapping
        ) {
            if (!iimclient.callIsDisabled) {
                window.NordicTracking.panel().setFunction(
                    window.NordicTracking.PANELINFO_FUNCTION_NAME_PHONE,
                    window.NordicTracking.PANELINFO_FUNCTION_STATUS_AVAILABLE
                );
            } else {
                window.NordicTracking.panel().setFunction(
                    window.NordicTracking.PANELINFO_FUNCTION_NAME_PHONE,
                    window.NordicTracking.PANELINFO_FUNCTION_STATUS_DIMMED
                );
            }

            // call is never closed, and should be handled differently in the css
            if (iimclient.callIsClosed) {
                window.NordicTracking.panel().setFunction(
                    window.NordicTracking.PANELINFO_FUNCTION_NAME_PHONE,
                    window.NordicTracking.PANELINFO_FUNCTION_STATUS_DIMMED
                );
            }
        } else {
            window.NordicTracking.panel().removeFunction(
                window.NordicTracking.PANELINFO_FUNCTION_NAME_PHONE
            );
        }

        if (
            !iimclient.hideEmailBox &&
            (!iimclient.segment ||
                (iimclient.segment && iimclient.segment.floater_emailisvisible) ||
                iimclient.testURLMapping)
        ) {
            window.NordicTracking.panel().setFunction(
                window.NordicTracking.PANELINFO_FUNCTION_NAME_EMAIL,
                window.NordicTracking.PANELINFO_FUNCTION_STATUS_AVAILABLE
            );
        } else {
            window.NordicTracking.panel().removeFunction(
                window.NordicTracking.PANELINFO_FUNCTION_NAME_EMAIL
            );
        }
    }

    getPageTitle() {
        return ifhelp2015api.getPageTitle(false);
    }
    // eslint-disable-next-line no-dupe-class-members
    getPageTitle(encodeHtmlEntities) {
        const iimclient = window.iimclient;
        const title = iimclient.pageTitle ? iimclient.pageTitle : document.title;
        if (encodeHtmlEntities)
            return (
                title &&
                title
                    .replace(
                        /ö|Ö|ä|Ä|å|Å|æ|Æ|ø|Ø/g,
                        (ch) =>
                            ({
                                // Encode special characters
                                ö: '&ouml;',
                                Ö: '&Ouml;',
                                ä: '&auml;',
                                Ä: '&Auml;',
                                å: '&aring;',
                                Å: '&Aring;',
                                æ: '&aelig;',
                                Æ: '&AElig;',
                                ø: '&oslash;',
                                Ø: '&Oslash;',
                            }[ch])
                    )
                    // eslint-disable-next-line no-control-regex
                    .replace(/[^\x00-\x7F]/g, '') // remove all non-ASCII characters
            );
        // eslint-disable-next-line no-control-regex
        else return title && title.replace(/[^\x00-\x7F]/g, ''); // remove all non-ASCII characters
    }

    getPageURL() {
        const iimclient = window.iimclient;
        const url = iimclient.pageURL ? iimclient.pageURL : window.location.href;
        return url;
    }

    getSegment(segmentId, cb) {
        const iimclient = window.iimclient;
        const url =
            iimclient.mypath +
            'api/segments' +
            (segmentId ? '/' + encodeURIComponent(segmentId) : '');

        axios({
            method: 'get',
            url: url,
            headers: {
                pageurl: encodeURI(window.ifhelp2015api.getPageURL()),
                pagetitle: window.ifhelp2015api.getPageTitle(),
            },
        })
            .then((res) => {
                if (cb) cb(null, res.data);
            })
            .catch((error) => {
                if (cb) cb(error.response.data);
            });
    }

    getSchedule(segmentId, cb) {
        const iimclient = window.iimclient;
        const url =
            iimclient.mypath + 'api/segments/' + encodeURIComponent(segmentId) + '/schedule';

        axios({
            method: 'get',
            url: url,
            headers: {
                pageurl: encodeURI(ifhelp2015api.getPageURL()),
                pagetitle: ifhelp2015api.getPageTitle(),
            },
        })
            .then((res) => {
                if (cb) cb(null, res.data);
            })
            .catch((error) => {
                if (cb) cb(error.response.data);
            });
    }

    isCallbackAvailable(segmentId, cb) {
        const iimclient = window.iimclient;
        const url =
            iimclient.mypath +
            'api/segments/' +
            encodeURIComponent(segmentId) +
            '/callback-available';

        axios({
            method: 'get',
            url: url,
            headers: {
                pageurl: encodeURI(ifhelp2015api.getPageURL()),
                pagetitle: ifhelp2015api.getPageTitle(),
            },
        })
            .then((res) => {
                if (cb) cb(null, res.data);
            })
            .catch((error) => {
                if (cb) cb(error.response.data);
            });
    }

    sendEventToCentalog(value, type, reason, result) {
        const iimclient = window.iimclient;
        const data = {
            userId: iimclient.email || 'Unknown',
            dataSubjectValue: value,
            accessType: type,
            accessData: window.location.href,
            accessResult: result || 'Success',
            businessReason: reason || '',
        };

        const myPagesUrl = this.getMyPagesUrl();
        const myBusinessUrl = this.getMyBusinessUrl();
        const directUrl = `${iimclient.mypath}api/centalog`;
        const url = myPagesUrl
            ? `${myPagesUrl}/api/proxy/ifhelp/api/centalog`
            : myBusinessUrl
            ? `${myBusinessUrl}/IfHelpApi/api/centalog`
            : directUrl;

        axios({
            method: 'post',
            url: url,
            data: data,
        }).catch(() => {
            if (url === directUrl) return;
            axios({
                method: 'post',
                url: directUrl,
                data: data,
            });
        });
    }

    orderCallback(segmentId, postData, cb) {
        const iimclient = window.iimclient;
        if (segmentId || segmentId == 0) {
            postData.pageurl = ifhelp2015api.getPageURL();
            postData.pagetitle = ifhelp2015api.getPageTitle();

            const callCode = 'phone_code' in postData ? postData['phone_code'] : '';
            const mobile = 'phone' in postData ? postData['phone'] : '';
            const url =
                iimclient.mypath +
                'api/segments/' +
                encodeURIComponent(segmentId) +
                '/order-callback';

            axios({
                method: 'post',
                url: url,
                data: postData,
            })
                .then((res) => {
                    ifhelp2015api.sendEventToCentalog(
                        `mobile=${callCode}${mobile}`,
                        'Create',
                        'Order callback'
                    );
                    if (iimclient.serviceEventId) {
                        window.ifhelp2015api.sendServiceEventValue('callbackOrdered');
                    } else {
                        // Check for identity
                        window.ifhelp2015api.getMypagesIdentity(function (err, identity) {
                            if (err) {
                                console.log('' + err);
                                return;
                            } else if (identity) {
                                window.ifhelp2015api.saveIdentity(identity);
                                if (identity.serviceEventId) {
                                    iimclient.serviceEventId = identity.serviceEventId;
                                    window.ifhelp2015api.sendServiceEventValue('callbackOrdered');
                                }
                            }
                        });
                    }
                    if (cb) cb(null, res.data);
                })
                .catch((error) => {
                    ifhelp2015api.sendEventToCentalog(
                        `mobile=${callCode}${mobile}`,
                        'Create',
                        'Order callback',
                        'Failure'
                    );
                    if (cb) cb(error.response.data);
                });
        } else {
            // no segment
            cb('missing initialization or required param'); // Can this potentially interfere with operation for finland?
        }
    }

    getAvailableWebCallbackTimes(segmentId, queueid, cb) {
        const iimclient = window.iimclient;
        const postData = {
            queueid: queueid,
            pageurl: ifhelp2015api.getPageURL(),
            pagetitle: ifhelp2015api.getPageTitle(),
        };
        const url =
            iimclient.mypath + 'api/segments/' + encodeURIComponent(segmentId) + '/availability';

        axios({
            method: 'post',
            url: url,
            data: postData,
        })
            .then((res) => {
                if (cb) cb(null, res.data);
            })
            .catch((error) => {
                if (cb) cb(error.response.data);
            });
    }

    getMyPagesUrl = () => getMyPagesUrl(this.getPageURL());
    getMyBusinessUrl = () => getMyBusinessUrl(this.getPageURL());
    getMobilityMyPagesUrl = () => getMobilityMyPagesUrl(this.getPageURL());
    getMobilityOpenPagesUrl = () => getMobilityOpenPagesUrl(this.getPageURL());

    isMobilityPagesUrl() {
        return (this.getMobilityMyPagesUrl() || this.getMobilityOpenPagesUrl()).length > 0;
    }

    listenToMobilityUrlChanges() {
        if (this.isMobilityPagesUrl()) {
            const togglePanelVisibilityWithFeatureToggle = (url, volviaToggle) => {
                const hide = hideFromMobilityUrl(url, volviaToggle);
                const eventName = hide ? 'addHidePanelReason' : 'removeHidePanelReason';
                window.dispatchEvent(new CustomEvent(eventName, { detail: 'hide-from-mobility' }));
                if (!hide) window.vngage?.evaluateOpportunities(); // Puzzel chat queue may change without page load
            };
            const togglePanelVisibility = (url) => {
                this.featureTogglePromise('ShowContactPanelForVolviaCommercialOpenPages')
                    .then(() => togglePanelVisibilityWithFeatureToggle(url, true))
                    .catch(() => togglePanelVisibilityWithFeatureToggle(url, false));
            };
            // Forward and back button clicks
            window.onpopstate = () => togglePanelVisibility(window.location.href);
            // Client side routing in SPA
            window.history.pushState = new Proxy(window.history.pushState, {
                apply: (target, thisArg, argArray) => {
                    const page = argArray && argArray.length > 2 && argArray[2] ? argArray[2] : '';
                    const url = new URL(page, window.location.origin).href;
                    togglePanelVisibility(url);
                    return target.apply(thisArg, argArray);
                },
            });
            // Page load
            togglePanelVisibility(window.location.href);
        }
    }

    convertToFormData(object) {
        const formData = new FormData();
        Object.keys(object).forEach((key) => {
            const value = object[key];
            if (typeof value !== 'object') formData.append(key, value);
            else formData.append(key, JSON.stringify(value));
        });
        return formData;
    }

    convertAxiosErrorToString(error) {
        return error.response && error.response.data
            ? JSON.stringify(error.response.data)
            : error.message;
    }

    hasIdentity() {
        return !!(
            this.#chatIdentity &&
            Object.values(this.#chatIdentity).filter((value) => value != null && value != undefined)
                .length
        );
    }

    saveIdentity(identity) {
        this.#chatIdentity = { ...identity };
    }

    // updateUrlWithParameter(key, value) {
    //     const url = new URL(window.location.href);
    //     url.searchParams.set(key, value);
    //     window.history.replaceState(null, null, url);
    // }

    storeUpdateEvent(event, sessionId) {
        if (!window.sessionStorage) return;

        const key = 'identity-' + event;
        const value = window.sessionStorage.getItem(key);

        if (!value) {
            window.sessionStorage.setItem(key, sessionId);
        } else if (!value.includes(sessionId)) {
            window.sessionStorage.setItem(key, value + ', ' + sessionId);
        }
    }

    getCountryByAccountId() {
        const accountId = this.getDEAccountId();
        const accountIds = {
            fi: '78006857-6CC0-4C9D-8654-89BE8A9E1BF8',
            dk: '3D6BF275-01F8-4DFA-8790-5D1A31C4DF61',
            no: 'D8F5A8A7-D02D-46ED-86CC-88F4F92D1DFB',
            se: '8F126DFB-3F0B-4E1B-89BC-2AD11B1944FF',
            test: '2F786A11-4288-45D8-A532-2E8C0DEEBAFC',
        };

        switch (accountId) {
            case accountIds.fi:
                return 'FI';
            case accountIds.dk:
                return 'DK';
            case accountIds.no:
                return 'NO';
            case accountIds.se:
                return 'SE';
            case accountIds.test:
                return 'test';
            default:
                return '';
        }
    }

    resetIdentity(sessionId, skipReset) {
        return new Promise((resolve) => {
            const iimclient = window.iimclient;
            if (!iimclient || skipReset) {
                resolve();
                return;
            }

            const url = iimclient.mypath + 'api/reset-identity';
            const data = {
                sessionId: sessionId,
                country: this.getCountryByAccountId(),
            };

            axios({
                method: 'post',
                url: url,
                data: data,
            })
                .then(resolve)
                .catch(resolve);
        });
    }

    updateDEChatIdentity(retryCount = 0) {
        const getUserId = () => window.sessionStorage?.getItem('enigma-user-id') || '';

        const iimclient = window.iimclient;
        if (!iimclient) return;

        const myPagesUrl = this.getMyPagesUrl();
        const myBusinessUrl = this.getMyBusinessUrl();
        const mobilityUrl = this.getMobilityMyPagesUrl();
        if (!myPagesUrl && !myBusinessUrl && !mobilityUrl) return;

        const ref = encodeURIComponent(window.location.href);
        const url = myPagesUrl
            ? `${myPagesUrl}/api/proxy/ifhelp/api/de-identity?app=myp&ref=${ref}`
            : myBusinessUrl
            ? `${myBusinessUrl}/IfHelpApi/api/de-identity?app=myb&ref=${ref}`
            : `${mobilityUrl}/ifhelp/api/de-identity?app=mob&ref=${ref}`;

        if (window.sessionStorage) {
            window.sessionStorage.setItem('identity-chat', 'true');
        }

        const sessionId = this.getDEChatSessionId(url);
        if (!sessionId) return;

        const userId = getUserId();
        if (
            userId &&
            window.sessionStorage &&
            window.sessionStorage.getItem('updated-chat') === sessionId &&
            window.sessionStorage.getItem('updated-user-id') === userId
        )
            return;

        this.storeUpdateEvent('started', sessionId);

        const requestIdentityUpdateWithReset = () => requestIdentityUpdate(false);
        const requestIdentityUpdateWithoutReset = () => requestIdentityUpdate(true);
        const requestIdentityUpdate = (skipReset) => {
            const identity = this.#chatIdentity || {};
            const accountId = this.getDEAccountId();
            let headers = {};
            let data = {
                ...identity,
                sessionId: sessionId,
                accountId: accountId,
                ref: window.location.href,
            };

            if (myBusinessUrl) {
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                };
                data = this.convertToFormData(data);
            }

            const dataKey = { ...identity, sessionId: sessionId };
            const hashKey = getHashKey(dataKey);

            // allow one active identity update
            if (this.#activeIdentityKey === hashKey) return;
            else this.#activeIdentityKey = hashKey;

            this.storeUpdateEvent('requested', sessionId);
            this.resetIdentity(sessionId, skipReset).then(() => {
                axios({
                    method: 'post',
                    url: url,
                    withCredentials: true,
                    headers: headers,
                    data: data,
                })
                    .then(() => {
                        if (window.sessionStorage) {
                            window.sessionStorage.setItem('updated-chat', sessionId);
                            window.sessionStorage.setItem('updated-user-id', userId);
                        }
                        this.storeUpdateEvent('succeeded', sessionId);
                    })
                    .catch(() => {
                        this.#activeIdentityKey = undefined;

                        if (retryCount < 1) {
                            retryCount++;
                            setTimeout(() => {
                                this.updateDEChatIdentity(retryCount);
                            }, retryCount * 15000);
                        } else {
                            this.storeUpdateEvent('failed', sessionId);
                        }
                    });
            });
        };

        requestIdentityUpdateWithReset();

        if (iimclient.augmentIdentity && !this.hasIdentity()) {
            iimclient
                .augmentIdentity()
                .then(() => {
                    if (this.hasIdentity()) requestIdentityUpdateWithoutReset(); // Trigger another update
                })
                .catch(() => {});
        }
    }

    // addDEChatSessionIdToUrl = () => {
    //     const key = 'decsid';
    //     const url = new URL(window.location.href);
    //     const id = url.searchParams.get(key);
    //     if (id) return id;

    //     const sessionIdFunc = window.vngage ? window.vngage.vngageSessionId : undefined;
    //     const sessionId = typeof sessionIdFunc === 'function' ? sessionIdFunc() : undefined;
    //     if (!sessionId) return undefined;

    //     url.searchParams.set(key, sessionId);
    //     window.history.replaceState(null, null, url);
    //     return sessionId;
    // };

    logEvent(data) {
        const iimclient = window.iimclient;
        if (!iimclient) return;

        axios({
            method: 'post',
            url: iimclient.mypath + 'api/logevent',
            data: data,
        })
            .then(() => {})
            .catch(() => {});
    }

    getDEChatSessionId(url) {
        const iimclient = window.iimclient;
        if (!iimclient || !window.vngage) return undefined;

        const sessionIdFunc = window.vngage.vngageSessionId;
        const sessionId = typeof sessionIdFunc === 'function' ? sessionIdFunc() : undefined;
        if (!sessionId && url) {
            this.logEvent({
                title: 'Missing session id',
                url: url,
            });
        }

        return sessionId;
    }

    getDEAccountId() {
        return window.vngage &&
            window.vngage.config &&
            window.vngage.config.comm &&
            window.vngage.config.comm.accountId
            ? window.vngage.config.comm.accountId.toUpperCase()
            : '';
    }

    initializeFeatureTogglesPromise() {
        const logToggleError = (error, origin) => {
            const data = {
                title: 'Failed to initialize toggles',
                error: error.response.data || '',
                status: error.response.status,
                message: error.message || '',
                url: origin + 'api/toggles',
            };
            axios({
                method: 'post',
                url: origin + 'api/logevent',
                data: data,
            })
                .then(() => {})
                .catch(() => {});
        };

        return new Promise((resolve, reject) => {
            if (this.#featureToggles.length) {
                resolve();
                return;
            }

            const origin = getScriptOrigin();
            if (!origin) {
                reject();
                return;
            }

            axios({
                method: 'get',
                url: origin + 'api/toggles',
            })
                .then((res) => {
                    this.#featureToggles = res.data || [];
                    resolve();
                })
                .catch((error) => {
                    logToggleError(error, origin);
                    console.log(error.response.data);
                    this.#featureToggles = [];
                    reject();
                });
        });
    }

    featureTogglePromise(toggleName) {
        return new Promise((toggleOn, toggleOff = () => {}) => {
            if (!toggleName) {
                toggleOff();
                return;
            }

            this.initializeFeatureTogglesPromise()
                .then(() => {
                    if (this.getFeatureToggle(toggleName)) toggleOn();
                    else toggleOff();
                })
                .catch(() => toggleOff());
        });
    }

    getFeatureToggle(toggleName) {
        if (!this.#featureToggles.length) {
            return false;
        }

        const toggle = this.#featureToggles.find((t) => t.name === toggleName);
        return toggle && toggle.value;
    }

    getMypagesIdentity(cb) {
        const iimclient = window.iimclient;
        const identity = {
            nickName: iimclient.nickName,
            email: iimclient.email,
            mobile: iimclient.mobile,
            serviceEventId: iimclient.serviceEventId,
        };

        // cache
        if (this.hasIdentity()) {
            cb(undefined, this.#chatIdentity);
            return;
        }

        const url = this.getMyPagesUrl();
        if (!url) {
            const cPage = window.ifhelp2015api.getPageURL();
            //console.log('No mypages integration for ' + cPage);
            cb('No mypages integration for ' + cPage, identity);
            return;
        }
        let language = '';
        if (iimclient.lang == 'lang_no') {
            language = 'no';
        } else if (iimclient.lang == 'lang_fi') {
            language = 'fi';
        } else if (iimclient.lang == 'lang_se') {
            const cPage = window.ifhelp2015api.getPageURL();
            if (/.if.fi/.test(cPage)) {
                language = 'sv-FI';
            } else {
                language = 'sv'; //se is wrong
            }
        } else if (iimclient.lang == 'lang_dk') {
            language = 'da'; //dk is wrong
        }

        if (!language) {
            cb(new Error('Language is empty'));
            return;
        }

        axios({
            method: 'get',
            url: url + '/api/users/getuserinfo?currentLanguage=' + language,
            withCredentials: true,
            timeout: 6000,
        })
            .then((res) => {
                this.handleMyPagesIdentityResponse(res.data, identity, cb);
            })
            .catch((error) => {
                const message = this.convertAxiosErrorToString(error);
                if (!/internal/.test(window.location.origin))
                    this.logEvent({
                        title: 'Identity update failed from mypages',
                        error: message,
                        url: window.location.href,
                    });
                cb(message, identity);
            });
    }

    handleMyPagesIdentityResponse(data, identity, cb) {
        if (!data || !data.IsLoggedIn || !data.DisplayName) {
            cb(new Error('Missing identity'));
            return;
        }

        const iimclient = window.iimclient;
        let firstName = '';
        let lastName = '';
        if (data.DisplayName.lastIndexOf(' ') >= 0) {
            firstName = data.DisplayName.substring(0, data.DisplayName.lastIndexOf(' '));
            lastName = data.DisplayName.substring(data.DisplayName.lastIndexOf(' '));
        } else {
            firstName = data.DisplayName;
        }

        if (firstName) firstName = firstName.trim();
        if (lastName) lastName = lastName.trim();
        const name = (firstName + ' ' + lastName).trim();
        let email = null;
        let customerId = null;
        let mobile = null;

        if (data.Email && data.Email.length > 0 && data.Email.indexOf('@') > 0) {
            email = data.Email;
        }

        if (data.CustomerNumber) {
            customerId = data.CustomerNumber;
        } else {
            this.logEvent({
                title: 'Customer number missing from mypages',
                error: JSON.stringify(data),
                url: window.location.href,
            });
        }

        if (data.Mobile) {
            mobile = data.Mobile.replace(/ /g, '').trim();
        }

        identity.nickName = name;
        identity.email = email;
        identity.customerId = customerId;
        identity.mobile = mobile;
        if (data.ServiceEventId) {
            identity.serviceEventId = data.ServiceEventId;
            iimclient.serviceEventId = data.ServiceEventId;
        }

        cb(null, identity);
    }

    sendServiceEventValue(action) {
        const iimclient = window.iimclient;

        if (!iimclient) return;

        if (!this.hasIdentity()) return;

        const identity = this.#chatIdentity;

        if (!identity.serviceEventId || !identity.customerId) return;

        // We have serviceEventId received from mypages and will do writeServiceTask
        const serviceEventValue = {
            startedTimestamp: identity.serviceEventId, //the service event id that MyPages has provided
            clientReference: identity.customerId, //the customernumber that MyPages has provided
            serviceTaskList: [], //ArrayOfServiceTask =  list of service tasks to be added so in your case just one ServiceTaskValue with following values:
            //TaskCode = either K06 or K12
            //entityTypeCode: 'CLIENT BASIC', //most probably “CLIENT BASIC”
            //entityTypePrimaryId: iimclient.customerId //the customernumber that MyPages has provided
        };
        switch (action) {
            case 'chatStarted':
                serviceEventValue.serviceTaskList.push({
                    taskCode: 'K06',
                    entityTypeCode: 'CLIENT BASIC',
                    entityTypePrimaryId: identity.customerId,
                });
                break;
            case 'callbackOrdered':
                serviceEventValue.serviceTaskList.push({
                    taskCode: 'K12',
                    entityTypeCode: 'CLIENT BASIC',
                    entityTypePrimaryId: identity.customerId,
                });
                break;
            default:
                return;
        }
        axios({
            method: 'post',
            url: iimclient.mypath + 'api/sendserviceeventvalue',
            data: { serviceEventValue: serviceEventValue },
        })
            .then(() => {})
            .catch(() => {});
    }

    convertLocalTimeToUTC(localTime) {
        const date = new Date();
        const hrs = localTime.split(':')[0];
        const mins = localTime.split(':')[1];
        date.setHours(hrs);
        date.setMinutes(mins);
        const hours = date.getUTCHours() < 10 ? '0' + date.getUTCHours() : date.getUTCHours();
        const minutes =
            date.getUTCMinutes() < 10 ? '0' + date.getUTCMinutes() : date.getUTCMinutes();
        let output = null;
        if (!isNaN(hours) && !isNaN(minutes)) output = hours + ':' + minutes;
        return output;
    }

    convertUTCTimeToLocal(UTCTime) {
        const now = new Date();
        const datestr =
            now.getFullYear() +
            '-' +
            (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1) +
            '-' +
            (now.getDate() < 10 ? '0' + now.getDate() : now.getDate());
        const timestr = UTCTime + ':00';
        const timezonestr = '000Z';
        const date = new Date(datestr + 'T' + timestr + '.' + timezonestr);
        const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        let output = null;
        if (!isNaN(hours) && !isNaN(minutes)) output = hours + ':' + minutes;
        return output;
    }

    phoneAvailablePoll(options, cb) {
        const iimclient = window.iimclient;
        if (iimclient.queues && (!options || !options.queue)) {
            throw new Error('Missing queue in options');
        }
        if (iimclient && iimclient.nopoll) return;

        const considerOpeningHours = function (cbCheckQueue) {
            let customerKey =
                iimclient.queues &&
                iimclient.queues[options.queue] &&
                iimclient.queues[options.queue].customerKey;
            let timeId =
                iimclient.queues &&
                iimclient.queues[options.queue] &&
                iimclient.queues[options.queue].timeId;
            if (!customerKey && iimclient.customerKey) customerKey = iimclient.customerKey;
            if (!timeId && iimclient.timeId) timeId = iimclient.timeId;
            if (customerKey && timeId) {
                window.PuzzelClient.timeExit(customerKey, timeId).then(function (t) {
                    if (t && t.Ok && t.Exit && !/open/i.test(t.Exit)) {
                        cb({
                            isAvailable: false,
                            phoneStatus: 'CLOSED',
                        });
                    } else cbCheckQueue();
                });
            } else cbCheckQueue();
        };
        considerOpeningHours(function () {
            let customerKey =
                iimclient.queues &&
                iimclient.queues[options.queue] &&
                iimclient.queues[options.queue].customerKey;
            if (!customerKey && iimclient.customerKey) customerKey = iimclient.customerKey;
            let phoneVisualQueueId =
                iimclient.queues &&
                iimclient.queues[options.queue] &&
                iimclient.queues[options.queue].phoneVisualQueueId;
            if (!phoneVisualQueueId && iimclient.phoneVisualQueueId)
                phoneVisualQueueId = iimclient.phoneVisualQueueId;

            if (customerKey && phoneVisualQueueId) {
                window.PuzzelClient.queueStatus(customerKey, phoneVisualQueueId).then(function (s) {
                    if (s && s.Ok && s.Queue && !(typeof s.Queue.QueueSize === 'undefined')) {
                        cb({
                            isAvailable: true,
                            phoneStatus: 'READY',
                            waitingTime: s.Queue.WaitTimeMax,
                            queueSize: s.Queue.QueueSize,
                        });
                    } else
                        cb({
                            isAvailable: false,
                            phoneStatus: 'ERROR',
                        });
                });
            } else
                cb({
                    isAvailable: false,
                    phoneStatus: 'ERROR',
                });
        });
    }

    containsHash(hash) {
        const hs = (function (a) {
            const hash = a.substr(1);
            const result = hash.split('&').reduce(function (result, item) {
                const parts = item.split('=');
                result[parts[0]] = parts[1];
                return result;
            }, {});
            return result;
        })(window.location.hash);

        return hs && Object.prototype.hasOwnProperty.call(hs, hash);
    }

    hashCheckWCB() {
        const self = this;
        const iimclient = window.iimclient;
        if (
            self.containsHash('web-callback') ||
            (iimclient.hadWebCallbackHash && Date.now() - iimclient.hadWebCallbackHash < 2000)
        ) {
            return true;
        } else return false;
    }

    hashCheckChat() {
        return window.location.hash.toLowerCase().startsWith('#human-chat');
    }
}
const ifhelp2015api = window.ifhelp2015api || new IfHelp2015Api();
window.ifhelp2015api = ifhelp2015api;

module.exports = ifhelp2015api;
